<script setup lang="ts">
interface Props {
	regionId: string | undefined;
	width: number | 18;
	height: number | 18;
}

defineProps<Props>();

const handleNotFoundImages = (e: any) => {
	e.target.src = "https://cms1.betwayafrica.com/medialibraries/content.gmgamingsystems.com/Synapse/icons/regions-leagues-flags/default-circular.svg";
};
</script>

<template>
	<NuxtImg
		:width="width"
		:height="height"
		provider="kentico"
		@error="handleNotFoundImages"
		:src="`/medialibraries/content.gmgamingsystems.com/Synapse/icons/regions-leagues-flags/${regionId}-circular.svg`"
	/>
</template>
